export class TeacherDto{
    id?:string;
    name!:string;
    email!:string;
    role!:string;
    bio!:string;
    profilePhotoUrl!:string;
    isActive!:boolean;
}
export class TeacherCreateDto{
    name!:string;
    email!:string;
    role!:string;
    bio!:string;
}